import fetch from '../utils/fetch'
import { RequestTrackingByOrderParams, RequestTrackingByChildrenParams, RequestTrackingBySellerParams } from '../types/tracking'

const byOrder = (params: RequestTrackingByOrderParams) => {
    return fetch({
        url: '/EstadoPedidoActionGetAllForPedidoFront',
        method: 'POST',
        data: { 'pedido.id': params.id }
    })
}

const byChildren = (params: RequestTrackingByChildrenParams) => {
    return fetch({
        url: '/PedidoActionGetPedidosHijos',
        method: 'POST',
        data: { 'idPadre': params.id }
    })
}

const bySeller = (params: RequestTrackingBySellerParams) => {
    return fetch({
        url: '/PedidoActionGetAllForConsultoraSinPaginar',
        method: 'POST',
        data: { 'consultora.id': params.id }
    })
}

const trackingService = {
    byOrder,
    byChildren,
    bySeller
}

export default trackingService
